module.exports = __webpack_public_path__ + "static/assets/e7ca279a08263d90b237bc4cea67b336.svg";